import Choices from 'choices.js';

class FormChoice {
    constructor (element, options) {
        const settings = {
            search: false,
            sort: true
        };

        this.settings = Object.assign({}, settings, options);

        this.element = element;
        this.$orgElement = null;
        this.choicesElement = null;
    }

    isValueNumber () {
        let number;
        const $$options = this.element.querySelectorAll('option');

        for (let index = 0; index < $$options.length; index++) {
            if (isNaN($$options[index].value)) {
                number = false;
            } else {
                number = true;
            }
        }

        return number;
    }

    buildCustomSelect ($element) {
        if (this.isValueNumber()) {
            this.settings.sort = false;
        }

        this.$orgElement = $element.cloneNode(true);

        this.choicesElement = new Choices($element, {
            itemSelectText: '',
            removeItemButton: false,
            duplicateItemsAllowed: true,
            searchEnabled: this.settings.search,
            shouldSort: this.settings.sort,
            classNames: {
                placeholder: 'choices__placeholder'
            }
        });

        return this.choicesElement;
    }

    initialize () {
        return this.buildCustomSelect(this.element);
    }
}

export { FormChoice };
